import React, { useMemo } from "react";
import styles from "./Login.module.scss";
import { SubmitHandler, useForm } from "react-hook-form";
import { AuthValueInterface } from "interface/interface";
import CustomButton from "atoms/customButton/CustomButton";
import { isValidEmail } from "lib/utils";
import { useDispatch } from "react-redux";
import { HANDLE_USER_LOGIN } from "store/auth/action.types";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import {  useSearchParams } from "react-router-dom";

const Login = () => {
	const { loginLoading } = useSelector((store: RootState) => store.auth);
	const dispatch = useDispatch();
	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		setError,
		// clearErrors,
	} = useForm<AuthValueInterface>({
		mode: "onChange",
		defaultValues: {
			email: "",
		},
	});
	const [searchParams] = useSearchParams();
	const isAppInstalled = useMemo(() => searchParams.get("appInstalled") || false, [searchParams]);

	const handleUserLogin = async (showToast = false) => {
		dispatch({ type: HANDLE_USER_LOGIN, payload: { showToast, email: getValues("email") } });
	};
	const onSubmit: SubmitHandler<AuthValueInterface> = async (data) => {
		const { email } = data;
		if (!isValidEmail(email.trim())) {
			setError("email", { type: "custom", message: "Please enter a valid email" });
		} else {
			handleUserLogin();
		}
	};
	return (
		<>
			<div className={`flex-column align-center justify-center ${styles.login}`}>
						<form onSubmit={handleSubmit(onSubmit)}>
                  <div className={`${styles.login__heading}`}>
                  {!isAppInstalled && <h2>Welcome to Swan</h2>}
                  </div>
							<div className={`${styles.login__formGroup}`}>
								<label>Email</label>
								<input
									placeholder="Enter your email"
									type="text"
									{...register("email", {
										required: "Email is required",
									})}
									name="email"
								/>
								{errors.email &&
									(errors.email.message ? (
										<span className={`${styles.error}`}>{errors.email.message}</span>
									) : (
										<span className={`${styles.error}`}>This field is required</span>
									))}
								<CustomButton buttonText="Login" type="submit" className="primary semibold rounded full" disabled={loginLoading} />
							</div>
						</form>
				
				</div>
		</>
	);
};

export default Login;
